import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export default function GenreTag({ children, tone = 'cool', className = '' }) {
  const classes = ['genre-tag', `genre-tag--${tone}`, className].filter(Boolean).join(' ');
  return <span className={classes}>{children}</span>;
}

GenreTag.propTypes = {
  children: PropTypes.node.isRequired,
  tone: PropTypes.oneOf(['cool', 'warm']),
  className: PropTypes.string,
};
